export function formatPhoneNumber(phoneNumber: string): string {
  const cleanPhoneNumber = phoneNumber.replace(/\D/g, '');

  switch (cleanPhoneNumber.length) {
    case 0:
      return '';
    case 1:
    case 2:
    case 3:
      return cleanPhoneNumber;
    case 4:
    case 5:
    case 6:
      return `(${cleanPhoneNumber.slice(0, 3)}) ${cleanPhoneNumber.slice(3)}`;
    default:
      const first = cleanPhoneNumber.slice(0, 3);
      const second = cleanPhoneNumber.slice(3, 6);
      const third = cleanPhoneNumber.slice(6, 10);
      return `(${first}) ${second}-${third}`;
  }
}
